module.exports = __webpack_public_path__ + "static/media/moving-truck.9a3fe568.jpg";